import get from 'lodash.get';
import {
  CorporatePage,
  DefaultMeta,
  TSectionDefault,
} from '../../../../../types/partner-page-types';
import { CardsMobileCarousel } from '../../../utils/cards-mobile-carousel';
import { SectionHeader } from '../../../utils/section-header';
import { useDataForPlans } from '../../../utils/use-plan-data';
import { toShowGenericSection } from './utils';

const defaultTitleDesc = {
  title: 'Plans for you',
  description: 'Here are some special plans for you',
};

interface IGenericSection {
  postData: CorporatePage;
  metaData: DefaultMeta;
}

export const GenericSection: React.FC<IGenericSection> = ({
  postData,
  metaData,
}): JSX.Element => {
  const { generic_section, slug } = postData;
  const cardData = useDataForPlans(generic_section.plans, slug);

  const sectionDefaults: TSectionDefault = get(
    metaData,
    'section_defaults.generic_plans',
    defaultTitleDesc
  );

  if (!toShowGenericSection(postData, metaData, generic_section)) return <></>;
  const classes = postData.self_itr.active ? 'pt-20' : 'py-20';
  return (
    <div className={classes}>
      {cardData ? (
        <>
          <SectionHeader
            heading={sectionDefaults.title}
            description={sectionDefaults.description}
          />
          <CardsMobileCarousel
            cardData={cardData}
            metaData={metaData}
            showPlanFooter={true}
            customInfinite={true}
            infinite={false}
            background="grey"
          />
        </>
      ) : null}
    </div>
  );
};
